import {
  GET_SUGGESTED_CATEGORY,
  GET_SUGGESTED_CATEGORY_SUCCESS,
  GET_SUGGESTED_CATEGORY_ERROR,
  GET_SUGGESTED_CATEGORY_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSuggestedCategory = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUGGESTED_CATEGORY:
      state = { ...state, loading: true, success: false, error: false, message: null };
      break;

    case GET_SUGGESTED_CATEGORY_SUCCESS:
      state = { ...state, data: action.payload, loading: false, success: true, error: false, message: null };
      break;

    case GET_SUGGESTED_CATEGORY_ERROR:
      state = { ...state, data: null, loading: false, success: false, error: true, message: action.payload };
      break;

    case GET_SUGGESTED_CATEGORY_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSuggestedCategory;
